"use client";
import { ArrowUpRight } from "lucide-react";
import Link from "next/link";
import { motion } from "framer-motion";

export default function Contact() {
  const socials = [
    { name: "LINKEDIN", url: "https://linkedin.com/in/adhwaithas" },
    { name: "GITHUB", url: "https://github.com/adhwaithas" },
    { name: "MEDIUM", url: "https://medium.com/@adhwaithas" },
    { name: "BUY ME A COFFEE", url: "https://www.buymeacoffee.com/adhwaithas" },
  ];

  return (
    <section id="contact" className="py-32 relative overflow-hidden bg-black">
      {/* Ambient Background Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[50vw] h-[50vw] bg-[#ff5500]/5 rounded-full blur-[140px] mix-blend-screen pointer-events-none z-0" />

      <div className="container px-4 mx-auto max-w-4xl text-center relative z-10">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-5xl md:text-8xl font-black tracking-tighter text-white mb-8"
        >
          LET'S WORK <br />
          <span className="text-muted-foreground/30">TOGETHER.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="text-xl text-muted-foreground mb-12 max-w-xl mx-auto"
        >
          Have an exciting project? I'm always open to discussing new
          opportunities and ideas.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <Link
            href="mailto:me@adhwaithas.dev"
            className="group inline-flex items-center gap-3 text-2xl md:text-3xl font-bold text-white hover:text-[#ff5500] transition-colors border-b border-white/20 hover:border-[#ff5500]/30 pb-1"
          >
            me@adhwaithas.dev
            <ArrowUpRight className="w-6 h-6 md:w-8 md:h-8 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
          </Link>
        </motion.div>

        <div className="mt-20 flex flex-wrap justify-center gap-6">
          {socials.map((social, idx) => (
            <motion.a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 + idx * 0.1 }}
              className="flex items-center gap-2 px-6 py-3 rounded-full bg-white/5 backdrop-blur-md border border-white/10 hover:bg-[#ff5500]/10 hover:border-[#ff5500]/30 hover:text-white shadow-lg hover:shadow-[#ff5500]/5 hover:-translate-y-1 transition-all duration-300 text-sm font-medium text-gray-300"
            >
              {social.name}
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
